export default "__VITE_ASSET__25c422dd__"